module.exports = __webpack_public_path__ + "img/PAI_Landing-Page_Mobile_18.c96b6ffa.jpg";